import React, {useEffect} from 'react';
import BazzarImg from '../assets/images/bazaar.png';
import { DownloadOutlined } from '@ant-design/icons';


import './less/index.less';


function MobileAppPage() {
    useEffect(() => {
        window.scrollTo(0, 0)
    });

    return (
        <div className="main">
            <div className="container">
                <div className="page-title">
                    <h1>دانلود اپلیکیشن مدیریت مدارس مدتاک</h1>
                </div>
                <h5 className="page-subtitle">

                </h5>

                <div className="download-box">

                    <a href="https://cafebazaar.ir/app/ir.madtalk.android" target="_blank">
                        <img src={BazzarImg} alt="کافه بازار" />
                    </a>

                    <a className="link-box" href="http://api.madtalk.ir/media/file1608250817.apk" target="_blank">
                        <DownloadOutlined />
                        دانلود با لینک مستقیم
                    </a>


                </div>
                <div className="info-box">
                    <h2>اطلاعات اپلیکیشن</h2>
                    <div>
                        <div className="info-item">
                            <span>
                                نام بسته :
                            <span>
                                    ir.madtalk.android
                            </span>
                            </span>
                        </div>
                        <div className="info-item">
                            <span>
                                ایمیل توسعه دهنده :
                            <span>
                                    madtalk1@protonmail.com
                            </span>
                            </span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default MobileAppPage;